import type { ListedZonesByJurisdictionBucketDto } from '../../../../services/commerceService.ts';

export function buildListedZonesByJurisdictionBuckets(
  ids: string[],
  idToJurisdiction: Record<string, number>,
  fallbackJurisdictionId: number
): ListedZonesByJurisdictionBucketDto[] {
  const byJur = new Map<number, string[]>();
  for (const id of ids) {
    let j = idToJurisdiction[id];
    if (j == null || !Number.isFinite(j)) j = fallbackJurisdictionId;
    if (!Number.isFinite(j) || j <= 0) continue;
    const cur = byJur.get(j) ?? [];
    if (!cur.includes(id)) cur.push(id);
    byJur.set(j, cur);
  }
  return Array.from(byJur.entries())
    .sort((a, z) => a[0] - z[0])
    .map(([jurisdiccionId, georefZonaIds]) => ({ jurisdiccionId, georefZonaIds }));
}

export function stableListedBucketsJson(buckets: ListedZonesByJurisdictionBucketDto[]): string {
  return JSON.stringify(
    [...buckets]
      .sort((a, z) => a.jurisdiccionId - z.jurisdiccionId)
      .map((x) => ({
        jurisdiccionId: x.jurisdiccionId,
        georefZonaIds: Array.from(new Set(x.georefZonaIds)).sort(),
      }))
  );
}
